<template>
  <h1>404 not found</h1>
</template>